import { render, staticRenderFns } from "./3-Store.vue?vue&type=template&id=277f4f3c&scoped=true"
import script from "./3-Store.vue?vue&type=script&lang=js"
export * from "./3-Store.vue?vue&type=script&lang=js"
import style0 from "./3-Store.vue?vue&type=style&index=0&id=277f4f3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277f4f3c",
  null
  
)

export default component.exports